export default {
  install(Vue) {
    Vue.prototype.get_position = async function(positionProperty) {
      const api = `${window.endpoints.api}/BasicInformation/position`;

      const params = {
        positionName: null,
        positionProperty,
        isEnabled: true,
      };

      const response = await this.$http.get(api, { params });
      return response.data.map(item => ({
        PositionCode: item.PositionCode,
        PositionName: item.PositionName,
      }));
    };
  },
};